import React, { Component, Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../../../../constants/initLng';
import { useTranslation } from "react-i18next";
import * as CPN from "antd";
import * as HMS from "../../../common/component/Index";
import * as Func from "../../../../../helpers/functions";
import moment from 'moment';
import Input from './../../../common/component/Input';

export const EditComponent = (props) => {

    const { t } = useTranslation();

    const deleteItem = () => {
        if (confirm(t('notification.sureRemove'))) { //eslint-disable-line
            props.onDeleteTours({ id: props.item.id })
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            {
                props.permisionActions && props.permisionActions.allowUpdate &&
                <Link to={`/tours/action/${props.item.id}`} className={`mr-2 colorPrimary`} title={t('item.user.editUser')}>
                    <CPN.Icon type="form" className="fs20" />
                </Link>
            }
            {
                props.permisionActions && props.permisionActions.allowDelete &&
                <CPN.Icon type="delete" className="fs20 colorPrimary" onClick={deleteItem} />
            }
        </div>
    )
};

export const TourLinePriceComponent = (props) => {
    const { t } = useTranslation();
    const onChange = (e, t) => {
        let params = Func.getValueForm(e);
        props.onChange(params)

    }

    return (
        <Fragment>
            <div className={`price-type-contain ${props.className}`} style={props.style}>
                <div className={`price-type-name`}>{t(`item.tour.priceType.${props.price.priceType}`)}:</div>
                <div className={`row mt-2 align-items-center`}>
                    <div className={`col-md-4`}>
                        <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            // dataValidation={props.price.originalPrice}
                            dataValidation={props.price.originalPrice && props.price.originalPrice}
                            labelTitle={t(`item.tour.originalPrice`)}
                        >
                            <Input placeholder="" type={`text`}



                                className={`form-control`}
                                name={`originalPrice`}
                                onChange={onChange}
                                value={props.price.originalPrice ? Func.formatMoney(Func.checkUndefine(props.price.originalPrice)) : ""} />
                        </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-5`}>
                        <HMS.FormWrapperInputComponent
                            dataValidation={props.price.salePrice && props.price.salePrice}
                            labelTitle={t(`item.tour.salePrice`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`salePrice`}
                                onChange={onChange}
                                value={props.price.salePrice ? Func.formatMoney(Func.checkUndefine(props.price.salePrice)) : ""} />
                        </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-3`}>
                        <button type={`button`} className="btn btn-danger mt-3" onClick={() => props.onDeletePrice()}>
                            <CPN.Icon type="delete" style={{ fontSize: '20px' }} />
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    )
};

export const DepartureDateComponent = (props) => {

    const { t } = useTranslation();
    const initPriceType = ['ADULT', 'OLDSTER', 'CHILD', 'NEWBORN', 'ANIMAL'];
    const [isShowPrice, setIsShowPrice] = useState(false);
    const [listPrice, setListPrice] = useState({});
    const [tabSelect, setTabSelect] = useState();
    const [objectTypePrice, setObjectTypePrice] = useState([]);
    const [arrayPriceType, setArrayPriceType] = useState(initPriceType);

    const showPrice = (i, k) => {
        let newPrice = { priceType: i };
        props.onAddPrice(newPrice, props.count);
        let newarrayPriceType = arrayPriceType;
        newarrayPriceType = Func.arrayRemoveItem(newarrayPriceType, i);
        setArrayPriceType(newarrayPriceType);
    };

    useEffect(() => {
        let arrayTabs = arrayPriceType;
        if (props.arrayData.id) {
            props.arrayData.prices.map(i => {
                if (arrayTabs.includes(i.priceType)) {
                    arrayTabs = Func.arrayRemoveItem(arrayTabs, i.priceType);
                }
            })
        }
        // else{
        //     arrayTabs = Func.arrayRemoveItem(arrayTabs, "ADULT");
        //     props.arrayData.prices = [{"priceType": "ADULT", "salePrice": props.data.adultSalePrice,"originalPrice": props.data.adultOriginalPrice}];
        // }
        setArrayPriceType(arrayTabs)
    });

    const onSavePrice = () => {
        let priceType = listPrice;
        let newarrayPriceType = arrayPriceType;
        newarrayPriceType = Func.arrayRemoveItem(newarrayPriceType, priceType.priceType);
        setArrayPriceType(newarrayPriceType);
        let newArray = objectTypePrice;
        newArray.push(listPrice);
        setObjectTypePrice(newArray);
        setIsShowPrice(false);
        props.onChange(null, newArray);
    };

    const onRemovePrice = (i, count) => {
        let newarrayPriceType = arrayPriceType;
        newarrayPriceType.push(i.priceType);
        setArrayPriceType(newarrayPriceType);
        props.onRemovePrice(i, count);
    }

    const onRemoveItem = (count) => {
        if (confirm(t('notification.sureRemove'))) { //eslint-disable-line
            props.removeItem(count);
        }
    };

    return (
        <HMS.FormWrapperItem classParent={`${props.disabled ? "hide" : ""}`} classChildren={`align-items-center`}>
            <div className="col-md-12" style={{ paddingBottom: 40 }}>
                <div className="row">
                    <div className={`col-md-7`}>
                        <HMS.FormWrapperInputComponent
                            labelTitle={t('item.tour.departureDateItem')}
                        >
                            <HMS.DatePickerComponent className={`form-control ticketDateTime`}
                                hmsComponent={`RangePicker`}
                                style={{ padding: 0, border: 0 }}
                                onChange={props.onChange} name={`departureDate`}
                                placeholder={[t('item.tour.from'), t('item.tour.to')]}
                                value={[props.arrayData.from && moment(props.arrayData.from), props.arrayData.to && moment(props.arrayData.to)]}
                            />
                        </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-5`}>
                        <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={props.data.seat}
                            // validation={validation.avatar}
                            labelTitle={t(`item.tour.seat`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`seat`} onChange={props.onChange}
                                value={props.arrayData ? Func.checkUndefine(props.arrayData[`seat`]) ? Func.checkUndefine(props.arrayData[`seat`]) : Func.checkUndefine(props.data.seat) : Func.checkUndefine(props.data.seat)} />
                        </HMS.FormWrapperInputComponent>
                    </div>
                    <div className="col-md-12" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', }}>
                        <div style={{ width: '100%' }}>
                            {
                                arrayPriceType.map((i, k) => {
                                    return (
                                        <CPN.Button key={k} type={(isShowPrice && tabSelect === i) ? "primary" : "dashed"}
                                            className={`mr-3 mb-2`} onClick={() => showPrice(i, k)}>
                                            {
                                                (isShowPrice && tabSelect === i) ? <CPN.Icon type={`loading`} /> :
                                                    <CPN.Icon type={`user`} />
                                            }
                                            {t(`item.tour.priceType.${i}`)}
                                        </CPN.Button>
                                    )
                                })
                            }
                        </div>
                        {
                            props.arrayData && props.arrayData[`prices`].length > 0 && props.arrayData[`prices`].map((i, k) => {
                                return (
                                    <TourLinePriceComponent key={k} count={k} price={i}
                                        style={{ width: '49%', marginRight: k % 2 === 0 ? '1%' : 0, marginLeft: k % 2 !== 0 ? '1%' : 0 }}
                                        data={props.data}
                                        onDeletePrice={() => onRemovePrice(i, props.count)}
                                        onChange={(price) => props.onChangePrice(props.count, k, price)}
                                    />
                                )
                            })
                        }
                    </div>
                </div>
            </div>

            {/* <div className={`col-md-3`}>
                <div className={`row`}>
                    {
                        arrayPriceType.map((i, k) => {
                            return (
                                <CPN.Button key={k} type={(isShowPrice && tabSelect === i) ? "primary" : "dashed"}
                                    className={`mr-3 mt-2   `} onClick={() => showPrice(i, k)}>
                                    {
                                        (isShowPrice && tabSelect === i) ? <CPN.Icon type={`loading`} /> :
                                            <CPN.Icon type={`user`} />
                                    }
                                    {t(`item.tour.priceType.${i}`)}
                                </CPN.Button>
                            )
                        })
                    }
                </div>
            </div> */}
            {/* <div className={`col-md-2 text-center`}>
                <button type={`button`} className="btn btn-primary btn-action-height" onClick={() => props.onSaveDeparture(props.count)}>
                    <CPN.Icon type="save" style={{ fontSize: '20px' }} />
                </button>
                <button type={`button`} className="btn btn-danger ml-2 btn-action-height" onClick={() => onRemoveItem(props.count)}>
                    <CPN.Icon type="delete" style={{ fontSize: '20px' }} />
                </button>
            </div> */}
            {/* <CPN.Button type={`link`} onClick={() => props.onRemoveSaveDeparture(props.count)} style={{ position: 'absolute', top: '10px', right: 0}}>
                <CPN.Icon type="close" style={{ fontSize: '20px' }} />
            </CPN.Button> */}
            <div style={{ position: 'absolute', bottom: '10px', right: 0, marginRight: '-10px' }}>
                <button type={`button`} className="btn btn-primary btn-action-height" onClick={() => props.onSaveDeparture(props.count)}>
                    <CPN.Icon type="save" style={{ fontSize: '20px' }} />
                </button>
                <button type={`button`} className="btn btn-danger ml-2 btn-action-height" onClick={() => onRemoveItem(props.count)}>
                    <CPN.Icon type="delete" style={{ fontSize: '20px' }} />
                </button>
                <button type={`link`} className="btn btn-collapse ml-2 btn-action-height" onClick={() => props.onRemoveSaveDeparture(props.count)} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    {t(`action.collapse`)} <CPN.Icon type="arrow-up" style={{ fontSize: '20px' }} />
                </button>
            </div>
            {/* <a onClick={() => props.onRemoveSaveDeparture(props.count)}>{t(`action.collapse`)}</a>    */}
        </HMS.FormWrapperItem>
    )
};

export const DepartureDateOnSave = (props) => {

    const { t } = useTranslation();

    const getAdultOriginPrice = () => {
        if (props.data.prices && props.data.prices.length > 0) {
            return props.data.prices.map(i => {
                if (i.priceType === "ADULT") {
                    return Func.formatMoney(Func.checkUndefine(i.originalPrice));
                }
            })
        }
        return t('validation.statusCode.code.6');
    }

    const getAdultSalePrice = () => {
        if (props.data.prices && props.data.prices.length > 0) {
            return props.data.prices.map(i => {
                if (i.priceType === "ADULT") {
                    return Func.formatMoney(Func.checkUndefine(i.salePrice));;
                }
            })
        }
        return t('validation.statusCode.code.6');
    }

    return (
        <HMS.FormWrapperItem classChildren={`align-items-center`} classParent={`mb-0`}>
            <div className={`col-md-3`}>
                <h3 className="">{t('item.tour.departureDateItem')}: </h3>
                <p><CPN.Icon
                    type="calendar" /> {props.data && props.data.from ? moment(props.data.from).format('DD-MM-YYYY') : t('validation.statusCode.code.6')}{props.data && props.data.to && ' - '}{props.data && props.data.to && <CPN.Icon
                        type="calendar" />} {props.data && props.data.to && moment(props.data.to).format('DD-MM-YYYY')}
                </p>
            </div>
            <div className={`col-md-2`}>
                <h3>{t(`item.tour.seat`)}: </h3>
                <p>{props.data ? props.data.seat ? props.data.seat : t('validation.statusCode.code.6') : t('validation.statusCode.code.6')}</p>
            </div>
            <div className={`col-md-2`}>
                <h3>{t(`item.tour.originalPrice`)}: </h3>
                <p>{getAdultOriginPrice()}</p>
            </div>
            <div className={`col-md-2`}>
                <h3>{t(`item.tour.salePrice`)}: </h3>
                <p>{getAdultSalePrice()}</p>
            </div>
            <div className={`col-md-2`}>
                <h3>{t(`item.tour.priceTypeHeader`)}: </h3>
                <p>{t(`item.tour.priceType.ADULT`)}</p>
            </div>
            <div className={`col-md-1 text-right`}>
                <button type={`button`} className="btn btn-primary"
                    onClick={() => props.onRemoveSaveDeparture()}>
                    <CPN.Icon type="edit" style={{ fontSize: '20px' }} />
                </button>
            </div>
        </HMS.FormWrapperItem>
    )
};

export const MultipleDepartureComponent = (props) => {
    const { t } = useTranslation();
    const initPriceType = ['OLDSTER', 'CHILD', 'NEWBORN', 'ANIMAL'];
    const [isShowPrice, setIsShowPrice] = useState(false);
    const [tabSelect, setTabSelect] = useState();
    const [arrayPriceType, setArrayPriceType] = useState(initPriceType);
    const [multipleData, setMultipleData] = useState(props.multiDepartureData);

    const showPrice = (i) => {
        let newPrice = { priceType: i };
        let newarrayPriceType = arrayPriceType;
        newarrayPriceType = Func.arrayRemoveItem(newarrayPriceType, i);
        setArrayPriceType(newarrayPriceType);
        multipleData.prices.push(newPrice);
    };

    const onChangePrice = (k, params) => {
        multipleData.prices[k] = {
            ...multipleData.prices[k],
            [params.name]: Func.convertStringToNumber(params.value, params.name, ['originalPrice', 'salePrice'])
        }
        props.onSetMultipleState(multipleData);
    }

    const onChange = (e) => {
        let params = Func.getValueForm(e);
        if (params.name == 'seat') {
            multipleData.seats = params.value;
        }
        else if (params.name == 'step') {
            multipleData.steps = params.value;

        }
        else if (params.name === 'departureDate') {
            multipleData.fromDate = params.value[0];
            multipleData.toDate = params.value[1];
        }
        props.onSetMultipleState(multipleData);
    };

    const onRemovePrice = (i) => {
        let newarrayPriceType = arrayPriceType;
        newarrayPriceType.push(i.priceType);
        setArrayPriceType(newarrayPriceType);
        multipleData.prices = Func.arrayRemoveItem(multipleData.prices, i);
        props.onSetMultipleState(multipleData);
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className={`col-md-6`}>
                        <HMS.FormWrapperInputComponent
                            labelTitle={t('item.tour.departureDateItem')}
                        >
                            <HMS.DatePickerComponent className={`form-control ticketDateTime`}
                                hmsComponent={`RangePicker`}
                                style={{ padding: 0, border: 0 }}
                                onChange={onChange} name={`departureDate`}
                                placeholder={[t('item.tour.from'), t('item.tour.to')]}
                                value={[multipleData.fromDate && moment(multipleData.fromDate), multipleData.toDate && moment(multipleData.toDate)]}
                            />
                        </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-3`}>
                        <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={multipleData.seats}
                            labelTitle={t(`item.tour.seat`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`seat`} onChange={onChange}
                                value={Func.checkUndefine(multipleData.seats)} />
                        </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-3`}>
                        <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={multipleData.steps}
                            labelTitle={t(`item.tour.step`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`step`} onChange={onChange}
                                value={Func.checkUndefine(multipleData.steps)} />
                        </HMS.FormWrapperInputComponent>
                    </div>
                    <div className={`col-md-12`}>
                        <div className={`row`} style={{margin: 0}}>
                            {
                                arrayPriceType.map((i, k) => {
                                    return (
                                        <CPN.Button key={k} type={(isShowPrice && tabSelect === i) ? "primary" : "dashed"}
                                            className={`mr-3 mt-2   `} onClick={() => showPrice(i)}>
                                            {
                                                (isShowPrice && tabSelect === i) ? <CPN.Icon type={`loading`} /> :
                                                    <CPN.Icon type={`user`} />
                                            }
                                            {t(`item.tour.priceType.${i}`)}
                                        </CPN.Button>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="col-md-12" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', }}>
                        {
                            multipleData && multipleData[`prices`].length > 0 && multipleData[`prices`].map((i, k) => {
                                return (
                                    <TourLinePriceComponent key={k} count={k} price={i}
                                        style={{ width: '49%', marginRight: k % 2 === 0 ? '1%' : 0, marginLeft: k % 2 !== 0 ? '1%' : 0 }}
                                        onDeletePrice={() => onRemovePrice(i)}
                                        onChange={(params) => onChangePrice(k, params)}
                                    />
                                )
                            })
                        }
                    </div>
                </div>
            </div>


        </div>
    )
};
